import { getUserTimeZone } from "../utils/user-helpers";

const Questionnaire = (app) => {
  app
    .post(
      "/questionnaire/save-athlete-changes",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        const { isDeleting } = body;

        if (!isDeleting) {
          assert(
            body.questions,
            400,
            "You need to provide a list with the questions"
          );
        }

        try {
          await api("athlete-questionnaire", {
            method: "POST",
            body,
          });

          flash("success", "Successfully updated");
          res.refreshWith({}, { url: "back", hash: "#_" });
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/add-template",
      async ({ api, assert, flash, req, res }) => {
        const { body, query } = req;
        const { templateId } = query;
        const method = templateId ? "PUT" : "POST";

        try {
          await api("questionnaire-template", {
            method: method,
            body: body,
          });

          flash(
            "success",
            `Successfully ${method === "POST" ? "added" : "updated"} template`
          );
          res.refreshWith(
            { "modal[type]": "questionnaire-templates", templateId: "" },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.refreshWith(
            { "modal[type]": "questionnaire-templates", templateId: "" },
            { url: "back", hash: "#_" }
          );
        }
      }
    )
    .post(
      "/questionnaire/assign-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        try {
          await api("questionnaire-template-assign", {
            method: "POST",
            body,
          });
          flash("success", "Successfully assigned");
          res.refreshWith({ modal: "" }, { url: "back", hash: "#_" });
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({ modal: "" }, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/remove-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;

        const {
          templateId,
          userToRequest = undefined,
          organizationOwner = undefined,
        } = body;

        try {
          await api(
            `questionnaire-template?templateId=${templateId}&userToRequest=${userToRequest}&organizationOwner=${organizationOwner}`,
            {
              method: "DELETE",
            }
          );

          flash("success", "Successfully removed");
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/add-default-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;

        try {
          await api("questionnaire-template/set-default", {
            method: "POST",
            body,
          });

          flash("success", "Successfully assigned default template");
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/remove-default-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;

        const {
          templateId,
          userToRequest = undefined,
          organizationOwner = undefined,
        } = body;

        const organizationOwnerParam = organizationOwner
          ? `&organizationOwner=${organizationOwner}`
          : "";
        const urlToRequest = `questionnaire-template/set-default?templateId=${templateId}&userToRequest=${userToRequest}${organizationOwnerParam}`;

        try {
          await api(urlToRequest, {
            method: "DELETE",
          });

          flash("success", "Successfully removed default template");
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/add-schedule",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;

        try {
          const { startDay, frequency } = body.schedule;

          assert(frequency, 400, "Select a frequency for the schedule");
          assert(startDay, 400, "Select a day for the schedule");

          const userTimeZone = getUserTimeZone();
          body.userTimeZone = userTimeZone;

          await api("athlete-questionnaire-schedule", { method: "POST", body });

          flash("success", "Successfully scheduled");
          res.refreshWith({ modal: "" }, { url: "back", hash: "#_" });
        } catch (error) {
          flash("error", error.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    );
};

export default Questionnaire;
